import { createActionFactory } from '../../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Email Integrations => ');

// ######################################################################################## //
// EMAIL TEMPLATE PICKER ACTIONS
// ######################################################################################## //

const openEmailTemplatePicker = createAction('open email template picker');
const closeEmailTemplatePicker = createAction('close email template picker');

//request the list of template emails from which to build the notification list
const fetchTemplateNotificationList = createAction('fetch the list of templates to build notification from');
//once the data was retrieved with success set the piker list from the state to keep track of the available templates
const setEmailTemplatePickerList = createAction(
  'set the list of available templates for the picker',
  (templateEmailList) => ({ templateEmailList })
);
const templateEmailListFetchFail = createApiFailureAction(' failed to fetch template email list');

//make a request  to add a new notification to the list
const addNewNotification = createAction('create new notification', (emailTemplateId) => ({ emailTemplateId }));
//add the new notification to the local state list
const addNewNotificationToLocalList = createAction('adding a new notification to the local list', (emailTemplate) => ({
  emailTemplate,
}));
const fetchNewEmailTemplateFail = createApiFailureAction('failed to fetch the new email template');

const updateTemplatePickerState = createAction('update template picker state', (templatePickerState) => ({
  templatePickerState,
}));

export default {
  closeEmailTemplatePicker,
  openEmailTemplatePicker,
  templateEmailListFetchFail,
  fetchTemplateNotificationList,
  setEmailTemplatePickerList,
  addNewNotification,
  fetchNewEmailTemplateFail,
  addNewNotificationToLocalList,
  updateTemplatePickerState,
};
